require('./register');
require('./login');
require('./forgot');
require('./account');
require('./addresses');
require('./companies');
require('./groups');
require('./group');
require('./ratings');
require('./coupons');
require('./reservation');
require('./newsletter');
require('./filters');
require('./search-widget');
require('./slider-search-widget');



// WEBPACK FOOTER //
// ./resources/assets/js/modules/index.js